import H1SuperHeading from './H1SuperHeading'
export default H1SuperHeading
